import { Trans } from '~/common/context';

import { Text } from '@wyz/ui';
import { ENTITIES_STATUSES } from '~/common/schemas';
import { ICustomer } from '~/common/types';

interface Props {
  customer: ICustomer;
}

const BADGE_TEXT = {
  [ENTITIES_STATUSES.ENABLED]: 'app.common.status.enabled',
  [ENTITIES_STATUSES.DISABLED]: 'app.common.status.disabled',
} as const;
const VARIANT = {
  [ENTITIES_STATUSES.ENABLED]: 'success',
  [ENTITIES_STATUSES.DISABLED]: 'danger',
} as const;

export const CustomerStatusCell = ({ customer }: Props) => {
  return (
    <Text color={VARIANT[customer.status]} weight='bold' heading='xxs'>
      <Trans i18nKey={BADGE_TEXT[customer.status]} />
    </Text>
  );
};
